<template>
  <b-row>
    <b-col cols="12" lg="8" offset-lg="2">
      <slot></slot>
    </b-col>
  </b-row>
</template>

<script>
//const axios = require('axios');
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>